import React ,{useEffect} from 'react'
import './About.css'
import nft_card from './Im/NFT card-5.png'
import hundred from './Im/hundred-point.png'
import ynot from './Im/ynot.jpg'
import mango from './Im/mango.png'
import reliance from './Im/reliance.png'
import tsl from './Im/tsl.png'
import avm from './Im/avm.jpg'

import team from './Im/team.png'
import shaamil from './Im/shaamil.png'
import yash from './Im/yash.png'
import nishant from './Im/nishant.png'
import ranjeeth from './Im/ranjeeth.png'
import sudhakar from './Im/sudhakar.png'
import Sanjay from './Im/Sanjay.png'
import Fotter from '../../Home/Home_modules/Footerr/footer'
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import ultimate from './Im/3Ultimate.png'
import legendary from './Im/4Legendary.png'
import common from './Im/1Common.png'
import uncommon from './Im/2Rare.png'
import nft_card2 from './Im/NFT card.png'
import showcase from './Im/Group 10498.png'
import advait from  './Im/advait.png'
import pratyush from './Im/pratyush.png'
import sivajilogo from './Im/sivajilogo.png'
import siddhant from './Im/Siddhant.png'
import Sylvester from './Im/syl.png'

function About() {
    let history = useHistory();

    useEffect(() => {
        const legendaryBtn = document.querySelector('.legendarybtn');
        const commonBtn = document.querySelector('.commonbtn');
        const uncommonBtn = document.querySelector('.uncommonbtn');
        const rareBtn = document.querySelector('.rarebtn');
        const rarityImage = document.getElementById('rarity');
        legendaryBtn.addEventListener('click', () => {
            rarityImage.setAttribute('src', legendary);
            
        });
        commonBtn.addEventListener('click', () => {
            rarityImage.setAttribute('src', common);
            
        });
        uncommonBtn.addEventListener('click', () => {
            rarityImage.setAttribute('src', uncommon);
            
        });
        rareBtn.addEventListener('click', () => {
            rarityImage.setAttribute('src', ultimate);
            
        });
    });
    
    
    return (
        <Router>
            <div>
        <div class="main">
            <div className="about-top">
                <div className="about-col1">
                    <img className="nft_card_image" src={nft_card} />
                    </div>
                    <div className="about-col2">
                        <h1>WHAT'RE WE ABOUT?</h1>
                        <p>Founded by cinephiles & blockchain enthusiasts, we’ve created a diverse and secure digital marketplace where you can buy, own and sell digital art from Indian cinema. Own the most impactful dialogues, scenes, and beautiful Digital art as NFTs with just the click of a button.
Ride the NFT wave with Diginoor.</p>
                        <button class="about-topbtn">GET YOUR FIRST COLLECTION NOW</button>
                        </div>
                </div>    


                <div className="about-section2">
                    <div className="section2-col1">
                    <h1>CINEPHILES ASSEMBLE<img className="title-icon" src={hundred}/><br/></h1>
                        <p>At Diginoor, we’ve teamed up with the biggest names in Indian cinema from Bollywood to Kollywood. All NFTs & digital art on our platform is created with the blessings & approval of all parties involved. We’re revolutionizing cinema fandom with our partners onboard every step of the way</p>
                        
                        </div>
                        <div className="section2-col2">
                        <div className="section2-card">
                        <button className="about-lo"></button>
                        <button className="about-lo"></button>
                        <button className="about-lo"></button>
                        <div className="about-card-menu">
                            <button className="about-showcase-top-dot"></button>
                            <button className="about-showcase-top-dot"></button>
                            <button className="about-showcase-top-dot"></button>
                        </div>
                        <div className="section2-cardim">
                        </div>
                        <div className="about-top-details">
                            <p className="about-card-title">shivaji</p>
                            <p className="about-top-card-title1">legendary</p>
                            <p className="about-top-card-title-price">$ 230  </p>
                        </div>
                        <div className="likebtn">
                            <span className="glyphicon gly-po glyphicon-heart-empty"> </span>
                        </div>

                    </div>
                        </div>
                    </div>  
                    <div className="about-section3">
                        <div className="section3-col1">
                        <img id="rarity" src={ultimate} />
                            </div>
                            <div className="section3-col2">
                            <h1>ELUSIVE & EXCLUSIVE<img className="title-icon" src={hundred}/></h1>
                        <p>Only a limited number of collectibles are released by us, so be sure to snag in demand releases as soon as you can. Check out our Diamond, Gold and Silver categories for all our film collectibles.</p>
                                <div class="section3-col2-btns">
                                    <button className="commonbtn">Common</button>
                                    <button className="uncommonbtn">Rare</button>
                                    <button className="rarebtn">Ultimate</button>
                                    <button className="legendarybtn">Legendary</button>
                                    </div>
                                </div>
                               
                        </div>  
                        <div className="about-section4">
                            <div className="section4-col1">
                            <h1>GROW BIG OR GO HOME<img className="title-icon" src={hundred}/></h1>
                        <p>Owning NFTs is a lot like owning stocks, with lesser risks & more visual appeal. You can watch your NFTs grow in value and choose to sell them to make high returns. Built on the polygon network, your NFT’s & Digital art are hosted and protected with the best security. It’s the perfect opportunity to invest & grow!</p>
                                
                                </div>
                                <div className="section4-col2">
                                <img src={nft_card2} />
                                    </div>
                        </div>
                        <div className="about-section5 about-section5-m">
                        <img src={showcase} />
                        </div>
                        <div className="section5-text section5-text-m">
                            <h2>YOUR OWN TIMELESS SHOWCASE</h2>
                            <p>Put your prized collection on display in curated Showcases on your profile. Build your collection from the ground up and create a collection that lasts generations. If you got it, flaunt it</p>
                        </div>
                        <div className="section6">
                        <div className="about-section6">
                            
                            <h2>OFFICIAL PARTNERS<img className="title-icon" src={hundred}/></h2>
                            <div className="section6-partners">
                                <div className="parnter-box">
                                    <img className="partner-im" src={ynot} />
                                    <h3>YPNOT Studios</h3>
                                    </div>
                                    <div className="parnter-box">
                                    <img className="partner-im" src={sivajilogo} />
                                    <h3>Sivaji Productions</h3>
                                    </div>
                                    <div className="parnter-box">
                                    <img className="partner-im" src={reliance} />
                                    <h3>Reliance Entertainment</h3>
                                    </div>
                                    <div className="parnter-box">
                                    <img className="partner-im" src={tsl} />
                                    <h3>Thenandal Studio</h3>
                                    </div>
                                    <div className="parnter-box">
                                    <img className="partner-im" src={avm} />
                                    <h3>AVM Productions</h3>
                                    </div>
                                </div>
                                <div className="section6-team">
                                    <h2>OUR TEAM</h2>
                                    <div className="team-box">
                                        <img className="team-im" src={shaamil} />
                                        <h3>Shaamil Karim</h3>
                                        <span>Founder & CEO</span>
                                        </div>
                                        <div className="team-box">
                                        <img className="team-im" src={yash} />
                                        <h3>Yash Rathod</h3>
                                        <span>Founder</span>
                                        </div>
                                        <div className="team-box">
                                        <img className="team-im" src={Sanjay} />
                                        <h3>Sanjay Wadhwa</h3>
                                        <span>Advisor</span>
                                        </div>
                                        <div className="team-box">
                                        <img className="team-im" src={ranjeeth} />
                                        <h3>Ranjeeth Rathod</h3>
                                        <span>Advisor</span>
                                        </div>
                                        <div className="team-box">
                                        <img className="team-im" src={nishant} />
                                        <h3>Nishant Ranka</h3>
                                        <span>Advisor</span>
                                        </div>
                                        <div className="team-box">
                                        <img className="team-im" src={sudhakar} />
                                        <h3>Sudhakar Kadavasal</h3>
                                        <span>Advisor</span>
                                        </div>
                                        <div className="team-box">
                                        <img className="team-im" src={siddhant} />
                                        <h3>Siddhant Kumar</h3>
                                        <span>COO</span>
                                        </div>
                                        <div className="team-box">
                                        <img className="team-im" src={Sylvester} />
                                        <h3>Sylvester </h3>
                                        <span>CTO</span>
                                        </div>
                                        <div className="team-box">
                                        <img className="team-im" src={advait} />
                                        <h3>Advaith George</h3>
                                        <span>Business Dev Head</span>
                                        </div>
                                        <div className="team-box">
                                        <img className="team-im" src={pratyush} />
                                        <h3>Pratyush Sarangi</h3>
                                        <span>UX Design Head</span>
                                        </div>
                                    </div>
                        </div>
        </div>
        </div>
        <Fotter/>
        </div>
    </Router>
    )
    
}

export default About
